import React from 'react';
import Button from '@material-ui/core/Button';

import resume from '../Media/resume/TLewis_CV.pdf'
import profile from '../Media/Tiffany.JPG'

const AboutMe = () => (


    <div className='AboutMe'>

        <h2> Biographical Highlights </h2>

        <Button href={resume} target="_blank">Curriculum Vitae</Button>
         <Button href={"mailto: tiffanylewisphd@gmail.com"} target="_blank">Email</Button>
        
<p>
</p>

        <img className='img-rounded' alt='Profile' src={profile} style={{height:'auto',width:'100%'}}></img>
        <p>
            I grew up in southern California, received my B.S. in Physics from George Washington University
            in 2012, my M.S. in Applied and Engineering Physics from George Mason University in 2014, and
            my Ph.D in Physics from George Mason University in 2018. I was featured in an Early Career Scientist Spotlight at NASA (https://science.gsfc.nasa.gov/600/ECSS/Tiffany-Lewis.html).
        </p>
        <p>
            I currently have a NASA Postdoctoral Program Fellowship hosted at the Astroparticle Physics Lab at Goddard Space Flight Center.  My research focuses on the development and application of theoretical models for blazar jets. In particular, the development of self-consistent leptohadronic particle transport methods that produce a range of electromagnetic emission scenarios alongside neutrino spectra to analyze TXS 0506+056 and predict the physical properties of other multi-messenger blazars. 
        </p>
        <p>
            I was a Zuckerman STEM Leadership Postdoctoral Scholar at the Center for Theoretical
            Physics & Astrophysics at the University of Haifa in Israel, working with Doron Chelouche, and
            the Department of Astrophysics at Tel Aviv University, working with Shai Kaspi.  The Zuckerman
            program provides full funding in addition to professional development in science communication
            and access to cultural events in Israel. 
        </p>
        <p>
        	   My dissertation work on analytic and numeric solutions to particle transport equations with
	           application to multiwavelength emission from blazar jets was performed under the advisement of
        	   Peter Becker at George Mason Univeristy and in collaboration with Justin Finke at the Naval
        	   Research Laboratory.
         </p>
        <p>
            My primary research has historically focused on high-energy particle acceleration and emission
            modeling in blazar jets. More recently, I have worked on expanding the models to consider the entire blazar spectrum and to differentiate between expressions of leptonic an leptohadronic interpretations.  I have also worked with ground based optical exoplanet observation,
            narrow band continuum AGN reverberation mapping observations, and line-locking simulations
            for AGN outflows with Cloudy software.
        </p>
         <p>
            My home language is C, and I am most familiar with bash and gnuplot scripting, although I have
            also worked extensively in several other languages.  I have used several meter and sub-meter
             class optical observatories.
        </p>
        <p>
            Additionally, I have worked extensively in astronomy education and community outreach.  I
            specialize in coordinating astronomy events and programs for children students, and the
            general public.  I have experience in program building, traditional and electronic advertising, and
            mentoring a diverse group of research and outreach trainees.  I am interested in the roll of group
             dynamics on learning in physics and astronomy, as well as the implementation and development of active learning environments.
        </p>

    </div>
)





export default AboutMe



// WEBPACK FOOTER //
// ./src/Components/AboutMe.js